import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  removeWishlistItems,
} from 'b2b-apps/shop/myAccount/wishlists/redux/wishlist/actionCreators';

type UseRemoveWishlistItemsActionReturnType = typeof removeWishlistItems;

const useRemoveWishlistItemsAction = (): UseRemoveWishlistItemsActionReturnType => {
  const dispatch = useDispatch();

  return useMemo(
    () => bindActionCreators(removeWishlistItems, dispatch),
    [
      dispatch,
    ],
  );
};

export type { UseRemoveWishlistItemsActionReturnType };
export { useRemoveWishlistItemsAction };
